module.exports = __webpack_public_path__ + "static/media/event_description.18bf4bfc.png";